import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, Button, TextField, IconButton, DialogTitle, DialogContent, DialogActions, Dialog, Icon } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment'
import ReactTable from "react-table";
import AssetUpload from '../asset/AssetUpload';
import * as assetActions from '../asset/store/actions'
import Menu from '@material-ui/core/Menu';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import TableCellTooltip from '../../components/TableCellTooltip';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // width: '100%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
});

class InstructorQualificationProfile extends Component {
    constructor(props) {
        super(props);
        const instructor_id = this.props.auth.user.data.role_info.link_id;
        this.props.getInstructorQualifications(instructor_id)
        this.props.getAllQualifications(instructor_id, 'profile')
        this.state = {
            ...this.state,
            instructor_id: instructor_id,
            dialogActive: false,
            selected_qual_id: 0,
            start: null,
            end: null,
            RequireAsset: 0,
            menuOpenRow: false,
            anchorEl: null,
            assetDialogOpen: false,
            assetDialogRow: false
        }
    }

    handleOpenMenu = (event, row) => {
        this.setState({ menuOpenRow: row.qualification_id, anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ menuOpenRow: null, anchorEl: null })
    }

    closeAssetDialog = () => {
        this.setState({ assetDialogRow: false, assetDialogOpen: false })
        this.props.updateQualificationAsset('clear');
        this.props.getInstructorQualifications(this.props.auth.user.data.role_info.link_id)
    }

    getDialog = (active) => {

        const qual_ids = this.props.qualifications.map(q => q.qualification_id);
        const mappedQuals = this.props.allQualifications.filter(q => qual_ids.indexOf(q.qualification_id) === -1)

        const qualItems = mappedQuals.map(q => {
            return (
                <MenuItem key={q.qualification_id} value={q.qualification_id}><b>{q.CompanyName}</b>: <span>{q.QualificationName}</span></MenuItem>
            )
        })

        return (

            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.handleCloseDialog()}
            >

                <DialogTitle>Apply for Qualification</DialogTitle>
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={8}>
                            <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                                <FormControl variant="outlined">
                                    <InputLabel
                                        ref={ref => {
                                            this.InputLabelRef = ref;
                                        }}
                                        htmlFor="outlined-age-simple"
                                    >
                                        Qualification
                                </InputLabel>
                                    <Select
                                        style={{ minWidth: '50px' }}
                                        value={this.state.selected_qual_id}
                                        onChange={
                                            (e) => {
                                                this.props.updateQualificationAsset('clear');
                                                // const reqAsset = e.target.value === 0 ? 0 : this.props.allQualifications.filter(q => q.qualification_id === e.target.value)[0].RequireAsset
                                                this.setState
                                                    ({
                                                        selected_qual_id: e.target.value,
                                                        // RequireAsset: reqAsset
                                                    })

                                            }
                                        }
                                        input={
                                            <OutlinedInput
                                                labelWidth={90}
                                                name="Qual"
                                                id="outlined-age-simple"
                                            />
                                        }
                                    >
                                        <MenuItem value={0}>
                                            <em>None</em>
                                        </MenuItem>
                                        {qualItems}
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                                <TextField
                                    variant={'outlined'}
                                    id="datetime-local"
                                    label="Start Date"
                                    type="date"
                                    defaultValue={moment().format('mm/dd/YYYY')}
                                    className={this.props.classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => this.setState({ start: e.target.value })}
                                />
                            </div>
                            <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                                <TextField
                                    variant={'outlined'}
                                    id="datetime-local"
                                    label="End Date"
                                    type="date"
                                    defaultValue={moment().format('mm/dd/YYYY')}
                                    className={this.props.classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => this.setState({ end: e.target.value })}
                                />
                            </div>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleApply()} color="primary" variant={'contained'} disabled={this.getApplyButtonDisabled()}>
                        Apply
                    </Button>
                    <Button onClick={() => this.handleCloseDialog()} variant="contained">
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getAssetDialog = (open) => {

        const assetList =
            this.props.qualificationAssetList.map(asset => {
                return (
                    <TableRow key={asset.asset_d}>
                        <TableCell>{asset.AssetName}</TableCell>
                    </TableRow>
                )
            })

        return (
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.handleCloseDialog()}
            >
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={4}>
                            <AssetUpload
                                file_type={"Instructor Qualification"}
                                auth_id={this.props.auth.user.data.auth_id}
                                modelType={"instructor_qualification"}
                                model_id={this.state.assetDialogRow.instructor_qualification_id}
                                requires_relation={true}
                                // responseFunction={this.props.updateQualificationAsset}
                                getAssetList={this.props.updateQualificationAsset}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <Table>
                                <TableBody>
                                    {assetList}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.closeAssetDialog()} variant="contained">
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getApplyButtonDisabled = () => {
        if (this.state.selected_qual_id === 0) {
            return true
        }
        // else if (this.state.RequireAsset === 1 && this.props.qualificationAssetList.length === 0) {
        //     return true
        // }
        return false
    }

    handleCloseDialog = () => {
        this.props.updateQualificationAsset('clear')
        this.setState({ dialogActive: false, selected_qual_id: 0, start: null, end: null, RequireAsset: 0 })
    }

    handleApply = () => {
        const qual = this.props.allQualifications.filter(q => q.qualification_id === this.state.selected_qual_id)[0]
        this.props.instructorQualificationApply(qual, this.state.instructor_id, this.state.start, this.state.end, this.props.qualificationAssetList)
        this.props.updateQualificationAsset('clear')
        this.setState({ dialogActive: false, selected_qual_id: 0, start: null, end: null, RequireAsset: 0 })
    }

    render() {
        const { anchorEl, menuOpenRow } = this.state
        const { auth, qualifications, classes } = this.props;

        const statusRow = (row) => {
            if (row.Approved === 1) {
                return (
                    <div className="flex items-center">
                        <Icon>check</Icon>
                    </div>
                )
            }
            else if (row.pending) {
                return (
                    <div className="flex items-center">
                        <Icon>more_horiz</Icon>
                    </div>
                )
            }
            else { return null }
        }

        const documentRow = (row) => {
            if (row.IsAsset === 0) {
                return null
            }
            else {
                if (row.assetList.length === 0) {
                    return (
                        <IconButton
                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                            onClick={() => this.setState({
                                assetDialogOpen: true,
                                assetDialogRow: row
                            })}
                        >
                            <Icon>add</Icon>
                        </IconButton>
                    )
                }
                else {
                    const menuItems = row.assetList.map(asset => {
                        return (
                            <MenuItem key={asset.asset_id} onClick={this.handleClose}>
                                <a href={asset.URL} target="_blank"><Icon>cloud_download</Icon>{asset.AssetName}</a>
                            </MenuItem>
                        )
                    })
                    return (
                        <div>
                            <IconButton
                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                aria-owns={anchorEl ? 'simple-menu' + row.qualification_id : undefined}
                                aria-haspopup="true"
                                onClick={(e) => this.handleOpenMenu(e, row)}
                                id={row.qualification_id}
                            >
                                <Icon>cloud_download</Icon>
                            </IconButton>
                            <Menu
                                id={"simple-menu" + row.qualification_id}
                                anchorEl={anchorEl}
                                open={row.qualification_id === menuOpenRow}
                                onClose={this.handleClose}
                            >
                                {menuItems}
                            </Menu>
                            <IconButton
                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                onClick={() => this.setState({
                                    assetDialogOpen: true,
                                    assetDialogRow: row
                                })}
                            >
                                <Icon>add</Icon>
                            </IconButton>
                        </div>
                    )
                }
            }
        }
        
        const applyDialog = this.getDialog(this.state.dialogActive)
        const assetDialog = this.getAssetDialog(this.state.assetDialogOpen)
        return (
            <Grid container spacing={8}>
                <Button
                    color={'primary'}
                    variant={'contained'}
                    onClick={() => this.setState({ dialogActive: true })}
                >
                    Apply
            </Button>
                {applyDialog}
                {assetDialog}
                <Grid item xs={12}>
                    <ReactTable
                        columns={[
                            {
                                Header: "Qualification Name",
                                // accessor: "QualificationName"
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.QualificationName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Qualification Desc",
                                // accessor: "QualificationDescription"
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.QualificationDescription}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Company Name",
                                accessor: "CompanyName",
                            },
                            {
                                Header: "Start",
                                id: "StartDate",
                                accessor: a => a.StartDate ? moment(a.StartDate).format('MM - DD - YYYY') : null
                            },
                            {
                                Header: "End",
                                id: "EndDate",
                                accessor: a => a.EndDate ? moment(a.EndDate).format('MM - DD - YYYY') : null
                            },
                            {
                                Header: "Status",
                                id: "Status",
                                width: 75,
                                accessor: a => statusRow(a)
                            },
                            {
                                Header: "Document",
                                id: "Document",
                                accessor: a => documentRow(a)
                            },
                        ]}
                        data={qualifications}
                        defaultPageSize={25}
                        className="-striped -highlight"
                        noDataText="No Qualifications Found"
                    />
                </Grid>
            </Grid>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInstructorQualifications: Actions.getInstructorQualifications,
        instructorQualificationApply: Actions.instructorQualificationApply,
        getAllQualifications: Actions.getAllQualifications,
        updateQualificationAsset: Actions.updateQualificationAsset,
        deleteAsset: assetActions.deleteAsset,
        addAssetToList: Actions.addAssetToList,
        dropAssetFromList: Actions.dropAssetFromList,
    }, dispatch);
}

function mapStateToProps({ instructorApp, auth }) {
    return {
        auth,
        qualifications: instructorApp.instructors.qualifications,
        allQualifications: instructorApp.instructors.allQualifications,
        qualificationAssetList: instructorApp.instructors.qualificationAssetList,
        currentInstructorCompanyList: instructorApp.instructors.currentInstructorCompanyList,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorQualificationProfile)));


// WEBPACK FOOTER //
// src/main/content/instructor/InstructorQualificationsProfile.js